var isIphone = require('./is-iphone');
var isIpod = require('./is-ipod');
var isAndroidPhone = require('./is-android-phone');
var isBlackberry = require('./is-blackberry');
var isMobileSize = require('./is-mobile-size');

module.exports = {
    'IsIphone': isIphone,
    'IsIpod': isIpod,
    'IsAndroidPhone': isAndroidPhone,
    'IsBlackberry': isBlackberry,
    'IsMobileSize': isMobileSize,
    'IsMobile': function() {
        return isIphone() || isIpod() || isAndroidPhone() || isBlackberry() || isMobileSize();
    }
};